// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Macintosh_Stroke2_Corner2_Rounded = createSinglePathSVG({
  path: 'M20.25 6.75a.75.75 0 0 1-.75.75h-3a.75.75 0 0 1 0-1.5h3a.75.75 0 0 1 .75.75ZM19.5 9h-3a.75.75 0 0 0 0 1.5h3a.75.75 0 0 0 0-1.5Zm3.75-4.5v15a1.5 1.5 0 0 1-1.5 1.5h-7.5a1.5 1.5 0 0 1-1.5-1.5V18H9v1.5h1.5a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1 0-1.5h1.5V18H3a2.25 2.25 0 0 1-2.25-2.25V9A2.25 2.25 0 0 1 3 6.75h9.75V4.5a1.5 1.5 0 0 1 1.5-1.5h7.5a1.5 1.5 0 0 1 1.5 1.5Zm-10.5 12V8.25H3a.75.75 0 0 0-.75.75v6.75a.75.75 0 0 0 .75.75Zm9 3v-15h-7.5v15h7.5ZM18 15.75a1.125 1.125 0 1 0 1.125 1.125A1.125 1.125 0 0 0 18 15.75Z',
  viewBox: '0 0 24 24',
  glyph: 'Macintosh_Stroke2_Corner2_Rounded',
})
